import { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const PinterestPinTitle = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 115 110"
        data-fill-none
      >
        <mask
          id="mask0_1529_12688"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="115"
          height="110"
        >
          <rect
            width="115"
            height="110"
            rx="8"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask0_1529_12688)">
          <rect
            x="-23"
            y="-2"
            width="151"
            height="115"
            rx="4.87097"
            fill="#FEF2F2"
          />
          <path
            d="M60.9924 74.0015H35.4543L20.861 84.9465V74.0015H13.5643C11.6186 74.0015 9.91602 72.2991 9.91602 70.3531V33.87C9.91602 31.9242 11.6186 30.2217 13.5643 30.2217H60.9924C62.9384 30.2217 64.6408 31.9242 64.6408 33.87V70.3531C64.6408 72.2991 62.9384 74.0015 60.9924 74.0015Z"
            fill="white"
            stroke="black"
            strokeWidth="0.913306"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="15.3586"
            y="52.7131"
            width="46.8831"
            height="2.43548"
            rx="0.608871"
            fill="#1E1E1E"
          />
          <rect
            x="15.3586"
            y="57.584"
            width="37.1411"
            height="2.43548"
            rx="0.608871"
            fill="#1E1E1E"
          />
          <rect
            x="15.3586"
            y="62.4551"
            width="26.1815"
            height="2.43548"
            rx="0.608871"
            fill="#1E1E1E"
          />
          <circle
            cx="17.7941"
            cy="38.7092"
            r="2.43548"
            fill="#1E1E1E"
          />
          <rect
            x="22.665"
            y="37.4915"
            width="23.1371"
            height="2.43548"
            rx="0.608871"
            fill="#1E1E1E"
          />
          <rect
            x="48.2378"
            y="37.4915"
            width="12.1774"
            height="2.43548"
            rx="0.608871"
            fill="#1E1E1E"
          />
          <path
            d="M48.4525 80.8622H67.0037L77.6046 88.8127V80.8622H82.905C84.3184 80.8622 85.5552 79.6255 85.5552 78.2119V51.71C85.5552 50.2966 84.3184 49.0598 82.905 49.0598H48.4525C47.0389 49.0598 45.8022 50.2966 45.8022 51.71V78.2119C45.8022 79.6255 47.0389 80.8622 48.4525 80.8622Z"
            fill="white"
            stroke="black"
            strokeWidth="0.913306"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M63.9772 72.7728C64.6671 73.5191 65.8429 73.5308 66.5476 72.7985L74.2594 64.7841C75.8495 63.194 76.2029 60.7205 75.3195 58.6003C73.7294 55.4201 69.3124 54.7134 66.8389 57.1869L65.4255 58.6003L64.0119 57.1869C61.3618 54.5367 57.1215 55.2434 55.5313 58.6003C54.4714 60.7205 54.8247 63.194 56.5915 64.7841L63.9772 72.7728Z"
            fill="#FF5A4F"
            stroke="black"
            strokeWidth="0.913306"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M64.6773 46.0158H9.87891V44.7981H64.6773V46.0158Z"
            fill="black"
          />
          <rect
            x="73.0492"
            y="21.5453"
            width="31.9657"
            height="31.9657"
            rx="15.9829"
            fill="white"
          />
          <rect
            x="73.0492"
            y="21.5453"
            width="31.9657"
            height="31.9657"
            rx="15.9829"
            stroke="#1E1E1E"
            strokeWidth="0.913306"
          />
          <path
            d="M80.5039 37.528C80.5039 41.02 82.6038 44.0199 85.6087 45.3389C85.5847 44.7434 85.6044 44.0285 85.7571 43.3806C85.9211 42.6883 86.8544 38.7337 86.8544 38.7337C86.8544 38.7337 86.582 38.1892 86.582 37.3845C86.582 36.1207 87.3145 35.1768 88.2267 35.1768C89.0024 35.1768 89.3772 35.7594 89.3772 36.4571C89.3772 37.2369 88.8798 38.4033 88.6241 39.4836C88.4104 40.3882 89.0777 41.1261 89.9701 41.1261C91.5859 41.1261 92.6742 39.0508 92.6742 36.592C92.6742 34.7229 91.4153 33.3239 89.1256 33.3239C86.5386 33.3239 84.927 35.2531 84.927 37.408C84.927 38.151 85.1461 38.6749 85.4892 39.0806C85.647 39.267 85.6689 39.3419 85.6118 39.5559C85.5709 39.7128 85.477 40.0906 85.438 40.2403C85.3813 40.4563 85.2063 40.5335 85.011 40.4538C83.8195 39.9673 83.2646 38.6625 83.2646 37.1957C83.2646 34.7732 85.3077 31.8684 89.3596 31.8684C92.6156 31.8684 94.7586 34.2245 94.7586 36.7536C94.7586 40.099 92.8987 42.5982 90.1571 42.5982C89.2364 42.5982 88.3703 42.1006 88.0736 41.5353C88.0736 41.5353 87.5785 43.5001 87.4736 43.8796C87.2928 44.5371 86.9389 45.1942 86.6153 45.7064C87.3823 45.9328 88.1925 46.0562 89.0323 46.0562C93.7416 46.0562 97.5601 42.238 97.5601 37.528C97.5601 32.8181 93.7416 29 89.0323 29C84.3225 29 80.5039 32.8181 80.5039 37.528Z"
            fill="#CB1F27"
          />
        </g>
      </SvgIcon>
    );
  })
);
